import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import DeckService from "../../../../services/catalogs/DeckService";

export const REQUEST_FETCH_DECKS = "REQUEST_FETCH_DECKS";
export const FETCH_DECKS_SUCCESS = "FETCH_DECKS_SUCCESS";
export const FETCH_DECKS_ERROR = "FETCH_DECKS_ERROR";

function requestFetchDecks() {
  return {
    type: REQUEST_FETCH_DECKS,
  };
}

function fetchDecksSuccess(json) {
  return {
    type: FETCH_DECKS_SUCCESS,
    decks: json.data,
  };
}

function fetchDecksError(json) {
  return {
    type: FETCH_DECKS_ERROR,
    error: json.data,
  };
}

export function fetchDecks() {
  return (dispatch) => {
    dispatch(requestFetchDecks());
    return DeckService.getDecks().then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchDecksSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchDecks());
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchDecksError(json.data));
      }
    });
  };
}
